module.exports = __webpack_public_path__ + "media/images/common/cancel_btn-54eb1921e8d6fe62a31715a539aea2db.png";